import React from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

export default function ArrowIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M19.78,11.78L18.36,13.19L12,6.83L5.64,13.19L4.22,11.78L12,4L19.78,11.78Z" />
    </SvgIcon>
  );
}
